import { differenceInMinutes } from 'date-fns';
import { IEnquiryFlight, EnumEnquiryFlightAgentType, EnumEnquiryFlightSeatingPlan, EnumEnquiryFlightBoardingPass } from '@simplyfly/shared';
export const getEnquiryFlightAgentTypeLabel = (type: EnumEnquiryFlightAgentType): string => {
  switch (type) {
    default:
      return type;
    case EnumEnquiryFlightAgentType.internal:
      return 'Interne';
    case EnumEnquiryFlightAgentType.external:
      return 'Externe';
  }
};

export const getEnquiryFlightFlyTimeInMin = (enquiryFlight: IEnquiryFlight): number => {
  if (enquiryFlight.flyTimeInMin) {
    return enquiryFlight.flyTimeInMin;
  } else {
    if (enquiryFlight.departDateTimeUtc && enquiryFlight.arrivalDateTimeUtc) {
      const arrivalDateTimeUtc: Date = new Date(enquiryFlight.arrivalDateTimeUtc + ':00Z');
      const departDateTimeUtc: Date = new Date(enquiryFlight.departDateTimeUtc + ':00Z');

      if (!isNaN(arrivalDateTimeUtc.getTime()) && !isNaN(departDateTimeUtc.getTime())) {
        return differenceInMinutes(arrivalDateTimeUtc, departDateTimeUtc);
      }
    }

    return 0;
  }
};

export const isAirlineVisibleForEnquiryFlight = (enquiryFlight: IEnquiryFlight): boolean => {
  if (
    typeof enquiryFlight.displayAirlineOnFlightBrief !== 'undefined' &&
    !enquiryFlight.displayAirlineOnFlightBrief
  ) {
    return false;
  }

  return true;
};

export const getEnquiryFlightSeatingPlanLabel = (
  seatingPlan: EnumEnquiryFlightSeatingPlan
): string => {
  switch (seatingPlan) {
    default:
      return seatingPlan;
    case EnumEnquiryFlightSeatingPlan.firstArrivedFirstServed:
      return 'FLIGHT_BRIEF.AIRPORT_INFORMATION.SEATING_PLANS.FIRST_ARRIVED_FIRST_SERVED';
    case EnumEnquiryFlightSeatingPlan.predefined:
      return 'FLIGHT_BRIEF.AIRPORT_INFORMATION.SEATING_PLANS.PREDEFINED';
    case EnumEnquiryFlightSeatingPlan.other:
      return 'FLIGHT_BRIEF.AIRPORT_INFORMATION.SEATING_PLANS.OTHER';
  }
};

export const getEnquiryFlightBoardingPassLabel = (
  boardingPass: EnumEnquiryFlightBoardingPass
): string => {
  switch (boardingPass) {
    default:
      return boardingPass;
    case EnumEnquiryFlightBoardingPass.handedOverCheckInCounter:
      return 'FLIGHT_BRIEF.AIRPORT_INFORMATION.BOARDING_PASSES.HANDED_OVER_CHECK_IN_COUNTER';
    case EnumEnquiryFlightBoardingPass.other:
      return 'FLIGHT_BRIEF.AIRPORT_INFORMATION.BOARDING_PASSES.OTHER';
  }
};
